import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import { connect } from "react-redux";

import MobileMenu from "./MobileMenu/MobileMenu";
import MenuButton from "../../components/Button/MenuButton/MenuButton";
import Button from "../../components/Button/Button";
import NavItems from "./NavItems/NavItems";

import "./Navbar.css";

class Navbar extends Component {
  state = {
    expanded: false,
  };

  toggleMenu = () => {
    this.setState((prevState) => {
      return { expanded: !prevState.expanded };
    });
    const body = document.querySelector("body");
    body.classList.toggle("masked");
  };

  render() {
    let menuClasses = "Menu";
    // let maskClasses = "Mask";
    if (this.state.expanded) {
      //   maskClasses += " expanded";
      menuClasses += " expanded";
    }
    return (
      <React.Fragment>
        <div className="Navbar">
          <MenuButton expanded={this.state.expanded} click={this.toggleMenu} />
          <NavLink to="/" className="side">
            <img
              alt="District Track Club Logo"
              className="Logo"
              src="https://districttrack.s3.us-east-2.amazonaws.com/v2/logos/dtc-logo.jpeg"
            />
            <img
              alt="District Track Club Logo"
              className="LogoInverted"
              src="https://districttrack.s3.us-east-2.amazonaws.com/v2/logos/DTC-logo-white.png"
            />
          </NavLink>

          <div className="fullScreenOnly">
            <NavItems />
          </div>

          <div className="fullScreenOnly side right">
            {this.props.userId ? (
              <Button buttonType="Black" size="sm" to="/logout">
                Sign Out
              </Button>
            ) : (
              <Button buttonType="Primary" size="sm" to="/auth">
                Log In
              </Button>
            )}
          </div>
        </div>
        <MobileMenu classes={menuClasses} click={this.toggleMenu}>
          <NavItems />
          <br />
          {this.props.userId ? (
            <Button buttonType="Black" size="sm" to="/logout">
              Sign Out
            </Button>
          ) : (
            <Button buttonType="Primary" size="sm" to="/auth">
              Log In
            </Button>
          )}
        </MobileMenu>
        {/* <div className={maskClasses}></div> */}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userId: state.userId,
  };
};

export default connect(mapStateToProps)(Navbar);
